async function getBanners(condition) {
  try {
    const resData = await window.axios.get('/api/v1/admin/banner', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findBannerById(id) {
  try {
    const resData = await window.axios.get(`/api/v1/admin/banner/${id}`);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateBanner(params) {
  try {
    const resData = await window.axios.put('/api/v1/admin/banner', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function creatBanner(params) {
  try {
    const resData = await window.axios.post('/api/v1/admin/banner', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteBanner(id) {
  const resData = await window.axios.delete('/api/v1/admin/banner', { params: { id } });
  return resData.data;
}

module.exports = { getBanners, findBannerById, updateBanner, creatBanner, deleteBanner };
